"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFormat = void 0;
const getFontFormat = (url) => {
    var _a;
    const ext = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (ext) {
        case 'woff2':
            return 'woff2';
        case 'woff':
            return 'woff';
        case 'otf':
            return 'opentype';
        case 'ttf':
            return 'truetype';
        default:
            throw new Error(`Could not automatically derive font format from extension: ${ext}. Pass the "format" parameter explicitly.`);
    }
};
exports.getFontFormat = getFontFormat;
